import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';

function OpComercialFilter(props) {
    const [next, setnext] = useState(false);
    const [cpc, setcpc] = useState(false);
    const [renting, setrenting] = useState(false);
    const [lineal, setlineal] = useState(false);
    const [refinanciacion, setrefinanciacion] = useState(false);
    const [refinanciacionnext, setrefinanciacionnext] = useState(false);
    const [autocredit, setautocredit] = useState(false);

    const filterChange = () => {
        if (next && cpc && renting) props.setProductoComercial('');
        else {
            var filterstr = '';
            if (next) filterstr = '158 ';
            if (cpc) filterstr += (filterstr.length > 0 ? ',' : '') + '134 ';
            if (renting)
                filterstr += (filterstr.length > 0 ? ',' : '') + '132 ';
            if (lineal)
                filterstr += (filterstr.length > 0 ? ',' : '') + '133 '
            if (refinanciacion)
                filterstr += (filterstr.length > 0 ? ',' : '') + '141 '
            if (autocredit)
                filterstr += (filterstr.length > 0 ? ',' : '') + '166 '
            if (refinanciacionnext)
                filterstr += (filterstr.length > 0 ? ',' : '') + '168 '
            props.setProductoComercial(filterstr);
        }
    };

    useEffect(() => {
        var _productoComercialfilterActive = false;
        props.filtersApplied.forEach(element => {
            if (element.filterName === 'Producto_comercial') {
                var filterstr = element.value.split(',');
                _productoComercialfilterActive = true;
                filterstr.forEach(_filterstr => {
                    if (_filterstr === '158 ') setnext(true);
                    if (_filterstr === '134 ') setcpc(true);
                    if (_filterstr === '132 ') setrenting(true);
                    if (_filterstr === '133 ') setlineal(true);
                    if (_filterstr === '141 ') setrefinanciacion(true);
                    if (_filterstr === '168 ') setrefinanciacionnext(true);
                    if (_filterstr === '166 ') setautocredit(true);
                });
            }
        });
        if (!_productoComercialfilterActive) {
            setnext(true);
            setcpc(true);
            setrenting(true);
            setlineal(true);
            setrefinanciacion(true);
            setautocredit(true);
            setrefinanciacionnext(true);
        }
    }, [props.filtersApplied]);

    useEffect(() => {
        filterChange();
    }, [next, cpc, renting, lineal, refinanciacion, autocredit, refinanciacionnext]);

    var _productoComercialfilterActive = false;
    var next_, cpc_, lineal_, renting_, refinanciacion_, autocredit_, refinanciacionnext_ = false;

    props.filtersApplied.forEach(element => {
        if (element.filterName === 'Producto_comercial') {
            var filterstr = element.value.split(',');
            _productoComercialfilterActive = true;
            filterstr.forEach(_filterstr => {
                if (_filterstr === '158 ') next_ = true;
                if (_filterstr === '134 ') cpc_ = true;
                if (_filterstr === '132 ') renting_ = true;
                if (_filterstr === '133 ') lineal_ = true;
                if (_filterstr === '141 ') refinanciacion_ = true;
                if (_filterstr === '168 ') refinanciacionnext_ = true;
                if (_filterstr === '166 ') autocredit_ = true;
            });
        }
    });
    if (!_productoComercialfilterActive) {
        next_ = true; 
        cpc_ = true; 
        renting_= true; 
        lineal_ = true;
        refinanciacion_ = true;
        refinanciacionnext_ = true;
        autocredit_ = true;
    }

    return (
        <section>
            <div className="u-1/1 u-text-left u-float-left u-pb-xsmall">
                <label className="c-checkbox pickupCheckbox u-float-left">
                    <input
                        className="c-checkbox__input"
                        type="checkbox"
                        onChange={() => setnext(!next)}
                        defaultChecked={next_}
                    />
                    <span className="c-checkbox__label checkbox-span"></span>
                </label>
                <label className="u-float-left">Financiación NEXT</label>
            </div>
            <div className="u-1/1 u-text-left u-float-left u-pb-xsmall">
                <label className="c-checkbox pickupCheckbox u-float-left">
                    <input
                        className="c-checkbox__input"
                        type="checkbox"
                        onChange={() => setcpc(!cpc)}
                        defaultChecked={cpc_}
                    />
                    <span className="c-checkbox__label checkbox-span"> </span>
                </label>
                <label className="u-float-left">Financiación CPC</label>
            </div>
            <div className="u-1/1 u-text-left u-float-left u-pb-xsmall">
                <label className="c-checkbox pickupCheckbox u-float-left">
                    <input
                        className="c-checkbox__input"
                        type="checkbox"
                        onChange={() => setrenting(!renting)}
                        defaultChecked={renting_}
                    />
                    <span className="c-checkbox__label checkbox-span"> </span>
                </label>
                <label className="u-float-left">Renting</label>
            </div>
            <div className="u-1/1 u-text-left u-float-left u-pb-xsmall">
                <label className="c-checkbox pickupCheckbox u-float-left">
                    <input
                        className="c-checkbox__input"
                        type="checkbox"
                        onChange={() => setlineal(!lineal)}
                        defaultChecked={lineal_}
                    />
                    <span className="c-checkbox__label checkbox-span"> </span>
                </label>
                <label className="u-float-left">Financiación Lineal</label>
            </div>
            <div className="u-1/1 u-text-left u-float-left u-pb-xsmall">
                <label className="c-checkbox pickupCheckbox u-float-left">
                    <input
                        className="c-checkbox__input"
                        type="checkbox"
                        onChange={() => setrefinanciacion(!refinanciacion)}
                        defaultChecked={refinanciacion_}
                    />
                    <span className="c-checkbox__label checkbox-span"> </span>
                </label>
                <label className="u-float-left">Refinanciación CPC</label>
            </div>
            <div className="u-1/1 u-text-left u-float-left u-pb-xsmall">
                <label className="c-checkbox pickupCheckbox u-float-left">
                    <input
                        className="c-checkbox__input"
                        type="checkbox"
                        onChange={() => setrefinanciacionnext(!refinanciacionnext)}
                        defaultChecked={refinanciacionnext_}
                    />
                    <span className="c-checkbox__label checkbox-span"> </span>
                </label>
                <label className="u-float-left">Refinanciación NEXT</label>
            </div>
            <div className="u-1/1 u-text-left u-float-left u-pb-xsmall">
                <label className="c-checkbox pickupCheckbox u-float-left">
                    <input
                        className="c-checkbox__input"
                        type="checkbox"
                        onChange={() => setautocredit(!autocredit)}
                        defaultChecked={autocredit_}
                    />
                    <span className="c-checkbox__label checkbox-span"> </span>
                </label>
                <label className="u-float-left">Financiación Autocredit</label>
            </div>
        </section>
    );
}

export default withRouter(OpComercialFilter);
